import { useEffect, useState } from 'react'
import { AppConfig } from '~/AppConfig'
import CloseIcon from '~/components/icons/Close_v2'

type SnackbarProps = {
  closable?: boolean
  mainText?: string
  helperText?: string
  action?: React.ReactNode
  icon?: React.ReactNode
  autoHide?: boolean
  autoHideDuration?: number
}


function Snackbar(props: SnackbarProps) {
  const {
    mainText,
    helperText,
    action = null,
    icon = null,
    closable,
    autoHide = true,
    autoHideDuration = AppConfig.SnackbarAutoHideDuration || 10000
  } = props
  const [visible, setVisible] = useState<boolean>(true)


  useEffect(() => {
    if (autoHide) {
      setTimeout(() => {
        setVisible(false)
      }, autoHideDuration)
    }
  }, [autoHide, autoHideDuration])

  if (!visible) return null

  return (
    <div
      className="flex items-center justify-between gap-1 rounded-lg bg-brand-primary-50 px-4 py-3.5"
      style={{
        boxShadow: `0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 4px 1px rgba(0, 0, 0, 0.15)`,
      }}
    >
      <div className="flex items-center gap-2">
        <div className="flex-shrink-0">{icon}</div>
        <div className="flex-col gap-1 text-sm text-brand-violet-950">
          <p className="font-medium">{mainText}</p>
          {helperText && <p className="font-light">{helperText}</p>}
        </div>
      </div>
      <div className="flex items-center justify-between gap-2">
        {action}
        {closable && (
          <div onClick={() => setVisible(false)}>
            <CloseIcon width="24" height="24" className="cursor-pointer text-brand-violet-950" />
          </div>
        )}
      </div>
    </div>
  )
}

export default Snackbar
